module.exports = __webpack_public_path__ + "img/98_1.2782ece5.png";